__turbopack_context__.v({
  "buttonClear": "wU9ZEG_buttonClear",
  "container": "wU9ZEG_container",
  "icon": "wU9ZEG_icon",
  "image": "wU9ZEG_image",
  "info": "wU9ZEG_info",
  "infoTop": "wU9ZEG_infoTop",
  "title": "wU9ZEG_title",
  "total": "wU9ZEG_total",
});
